import { NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { pairwise, startWith, tap } from 'rxjs/operators';

import store, { epicDependencies, storeObserver } from '../store';
import { pluck } from '../store.decorator';

/** @deprecated use useSelector2 */
export const useSelector = <TState>(
    path: string,
    fn: (state: TState) => void,
): Observable<TState> => {
    const ngZone = epicDependencies.injector.get<NgZone>(NgZone); // TODO revise
    return storeObserver<any, TState>(store, (state) =>
        pluck<TState>(state, path),
    ) // TODO revise store import
        .pipe(
            tap((state) => {
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                if (ngZone) {
                    ngZone.run(() => fn(state));
                } else {
                    fn(state);
                }
            }),
        );
};

export const useSelector2 = <TState>(
    mapper: (state: any) => TState,
): Observable<[TState, TState]> => {
    return storeObserver<any, TState>(store, mapper) // TODO revise store import
        .pipe(startWith<any, TState>(mapper(store)), pairwise());
};
